module.exports = __webpack_public_path__ + "media/images/350x150-2-5e80df46988b4b348c40c85365b48a3a.jpg";